import { type FieldContentsData } from 'javascripts/shared-types';
import { Project } from 'components/framework/models';
import Field, { type Flavor } from '../../Field';

export class StatusPill extends Field {
  static get availableForFlavors(): readonly Flavor[] {
    return ['roadmap', 'ideas'];
  }

  static subqueriesForModel() {
    return {
      project: Project.select(['isTeam']),
      workflowStatus: ['name', 'color'],
    };
  }

  get title() {
    return 'Status pill';
  }

  exampleContents(): FieldContentsData {
    return { pill: { text: 'Under consideration', color: '#5793BC' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (!record.project?.isTeam && record.workflowStatus) {
      return {
        pill: {
          text: record.workflowStatus.name,
          color: record.workflowStatus.color,
        },
      };
    }

    return {};
  }
}
